/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { FaArrowRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Sorting from "../../../Common/Sorting";
import MetaHead from "../../../Common/Metahead";
import { sortingAPIList } from "../../../../utilities/enums";
import Search from "../../../Common/Search";
import { connect } from "react-redux";
import Paginations from "../../../Common/Pagination";
import { campaignList } from "../../../../stores/actions/campaign.actions.types";
import CampaignTable from "../../../Tables/CampaignTable";

const CartFunnelSmsCampaign = ({ campaignList, loading }) => {
  const { t } = useTranslation();

  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [campaigns, setCampaigns] = useState([]);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState([
    {
      whom: "updatedAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    getCampaigns(pagination.page, sorting, search);
  }, [sorting, pagination.page, search]);

  const getCampaigns = (page, sort, search) => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, campaigns } = data?.data;

        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));

        setCampaigns(campaigns);
      }
    };

    let request = {
      callback,
      data: { type: "cart-funnel-sms", page, sort, q: search },
    };
    campaignList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  return (
    <div>
      <MetaHead title={t("sms-campaign-list")} />

      <div className='flex  flex-col sm:flex-row justify-end mb-3 gap-2'>
        <Search
          placeholder='Campaign Name'
          search={search}
          setSearch={setSearch}
        />
        <Sorting
          name={"Sort"}
          values={sortingAPIList}
          onChange={handleChangeSorting}
        />
        <button className='rounded-md bg-red-600 px-4 py-1 text-white'>
          Create New Campaign
        </button>
      </div>

      {loading ? (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : campaigns?.length ? (
        <div>
          <CampaignTable campaigns={campaigns} setCampaigns={setCampaigns} />
          <Paginations pagination={pagination} setPagination={setPagination} />
        </div>
      ) : (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          Not found
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  campaignList,
})(CartFunnelSmsCampaign);
